import { createStore, applyMiddleware } from 'redux';
import reducer from '../reducers';
import { hooksMiddleware, registerHooks, deregisterHooks } from './hooks';

const logger = store => next => (action) => {
    console.group(action.type);
    console.info('dispatching', action);
    const result = next(action);
    console.log('next state', store.getState());
    console.groupEnd();
    return result;
};

declare let module: {
    hot: {
        accept(path?: string, callback?: () => void): void;
    };
};

const configureStore = () => {
    const createStoreWithMiddleware = applyMiddleware(hooksMiddleware, logger)(createStore);
    const store = createStoreWithMiddleware(reducer);

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers', () => {
            // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
            const nextReducer = require('../reducers');
            store.replaceReducer(nextReducer);
        });
    }
    return store;
};

export { registerHooks, deregisterHooks };
export default configureStore();
